"use server";
import React from "react";
import BottomTab from "./bottom-tab/BottomTab";
import Drawer from "./drawer/Drawer";
import Header from "./header/Header";
import styles from "./navigatior-provider.module.css";
import { useAuth } from "../auth/auth";

interface Props {
  children: React.ReactNode;
  isHeader?: boolean;
  isDrawer?: boolean;
  isBottomTab?: boolean;
}

export default async function NavigatorProvider({
  children,
  isHeader = true,
  isDrawer = true,
  isBottomTab = true,
}: Props) {
  const { isAuthenticated } = await useAuth();
  return (
    <div className={styles.container}>
      {isHeader && <Header isAuthenticated={isAuthenticated} />}

      <div className={styles.drawerWrapper}>
        {isDrawer && <Drawer headerSection isAuthenticated={isAuthenticated} />}

        <div
          className={`${styles.children} ${
            isBottomTab && styles.bottomTabActive
          }`}
        >
          {children}
        </div>
      </div>

      {isBottomTab && <BottomTab />}
    </div>
  );
}
